import { render, staticRenderFns } from "./ManageSensorsView.vue?vue&type=template&id=492bd066"
import script from "./ManageSensorsView.vue?vue&type=script&lang=js"
export * from "./ManageSensorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports